import { render } from "./CharacterButtons.vue?vue&type=template&id=2b77e8a4"
import script from "./CharacterButtons.vue?vue&type=script&lang=js"
export * from "./CharacterButtons.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./CharacterButtons.vue?vue&type=style&index=0&id=2b77e8a4&lang=scss&module=s"
cssModules["s"] = style0

import exportComponent from "/usr/share/nginx/production/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__